
const getUrlParam = (param) => {
  if (!param) return "";
  const segments = param?.split("/");
  return segments[segments?.length - 1];
};
export default getUrlParam;